import {RegistroEntrenador } from '../../system/RegistroEntrenador/RegistroEntrenador';
import {Club } from '../../system/Club/Club';
import {Categoria } from '../../system/Categoria/Categoria';
import CustomForm from '../../lib/FormValidator/Form/CustomForm'
import { RegistroEntrenadorAntiguedad } from '../../system/RegistroEntrenadorAntiguedad/RegistroEntrenadorAntiguedad'
import { RegistroEntrenadorAntiguedadAssertions } from '../../system/RegistroEntrenadorAntiguedad/RegistroEntrenadorAntiguedadAssertions'
class RegistroEntrenadorAntiguedadForm extends CustomForm {
    protected constructor(
    reanti_id: string,
    reanti_reid: string,
    reanti_clubid: string,
    reanti_catid: string,
    reanti_anio_desde: number | null,
    reanti_anio_hasta: number | null,
    reanti_tipo: string,
    club: Club | null,
    categoria: Categoria | null)
    {const rea = RegistroEntrenadorAntiguedadAssertions.build()
    super("RegistroEntrenadorAntiguedad", rea)
    this.addInputAsserted('reanti_id', reanti_id)
    this.addInput('reanti_reid', reanti_reid)
    this.addInput('reanti_clubid', reanti_clubid)
    this.addInput('reanti_catid', reanti_catid)
    this.addInput('reanti_anio_desde', reanti_anio_desde)
    this.addInput('reanti_anio_hasta', reanti_anio_hasta)
    this.addInput('reanti_tipo', reanti_tipo)
    this.addInput('club', club)
    this.addInput('categoria', categoria)
}

private static build( reanti_id: string,
reanti_reid: string,
reanti_clubid: string,
reanti_catid: string,
reanti_anio_desde: number | null,
reanti_anio_hasta: number | null,
reanti_tipo: string ,
club: Club | null,
categoria: Categoria | null) {
    return new this( reanti_id,
    reanti_reid,
    reanti_clubid,
    reanti_catid,
    reanti_anio_desde,
    reanti_anio_hasta,
    reanti_tipo ,
    club,
    categoria)
}

static initialize() {
    return this.build( 'new',
    '',
    '',
    '',
    null,
    null,
    '' ,
    null,
    null)
}

static with(entity: RegistroEntrenadorAntiguedad) {
    return this.build(entity.getId(),
    entity.getReid(),
    entity.getClubid(),
    entity.getCatid(),
    entity.getAnioDesde(),
    entity.getAnioHasta(),
    entity.getTipo(),
    entity.getClub(),
    entity.getCategoria())
}

getIdInput() { return this.getInputByName('reanti_id') }

getReidInput() { return this.getInputByName('reanti_reid') }

getClubidInput() { return this.getInputByName('reanti_clubid') }

getCatidInput() { return this.getInputByName('reanti_catid') }

getAnioDesdeInput() { return this.getInputByName('reanti_anio_desde') }

getAnioHastaInput() { return this.getInputByName('reanti_anio_hasta') }

getTipoInput() { return this.getInputByName('reanti_tipo') }

getClubInput() { return this.getInputByName('club')}

getCategoriaInput() { return this.getInputByName('categoria')}

toRegistroEntrenadorAntiguedad(): RegistroEntrenadorAntiguedad {
    return RegistroEntrenadorAntiguedad.createFrom(
    this.getIdInput().getValue(),
    this.getReidInput().getValue(),
    this.getClubidInput().getValue(),
    this.getCatidInput().getValue(),
    this.getAnioDesdeInput().getValue(),
    this.getAnioHastaInput().getValue(),
    this.getTipoInput().getValue() ,
    this.getClubInput().getValue(),
    this.getCategoriaInput().getValue())
}

}

export default RegistroEntrenadorAntiguedadForm
